// src/app/page.tsx
import { FC, ReactNode, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Modal,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { CustomButton } from "./Button";
import { CiCircleQuestion } from "react-icons/ci";
import { tokensCost } from "../utils/functions";
export const ConfirmationDialog = ({
  handleClose,
  open,
  title,
  content,
  btn1,
  btn2,
  handleBtn1 = () => {},
  handleBtn2 = () => {},
  icon = undefined,
  actions = true,
  tooltip = "",
  tokens = undefined,
  bgcolor = "",
}: {
  handleClose?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  handleBtn1?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  handleBtn2?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  actions?: boolean;
  open: boolean;
  title: string;
  content: string;
  btn1: string;
  btn2: string;
  icon?: ReactNode;
  tooltip?: string;
  tokens?: number;
  bgcolor?: string;
}) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: bgcolor || theme.palette.background.default,
          backgroundImage: "initial",
          textAlign: "center",
          width: { xs: "80%", sm: "22%" },
          boxShadow: "0 0 5px #222 !important",
          borderRadius: "10px",
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        color={title == "WARNING" || title == "Confirmation" ? "" : "secondary"}
      >
        <div>
          {icon}
          <div>{title}</div>
        </div>
        {tooltip ? (
          <Tooltip title={tooltip}>
            <div style={{ position: "absolute", right: "17px", top: "17px" }}>
              <CiCircleQuestion />
            </div>
          </Tooltip>
        ) : null}
      </DialogTitle>
      <DialogContent sx={{ padding: "0px 20px 10px 20px !important" }}>
          <Typography component="div"
            textAlign={"justify"}
            fontWeight={"400"}
            color={
              title == "WARNING" || title == "Confirmation"
                ? "initial"
                : "secondary"
            }
          >
            {content}
          </Typography>
      </DialogContent>
      {actions ? (
        <DialogActions
          sx={{
            padding: "10px !important",
            gap: { xs: "5px", sm: "0px" },
            justifyContent: "center",
          }}
        >
          {btn1 ? (
            <div style={{ minWidth: "fit-content" }}>
              <CustomButton
                text={btn1}
                color={
                  title == "WARNING" || title == "Confirmation"
                    ? "white"
                    : "rgba(33, 143, 84, 1)"
                }
                border={
                  title == "WARNING" || title == "Confirmation"
                    ? "1px solid white"
                    : "1px solid rgba(33, 143, 84, 1)"
                }
                bgcolor={
                  title == "WARNING" || title == "Confirmation"
                    ? "initial"
                    : theme.palette.background.default
                }
                submit={handleBtn1}
                fontWeight="600"
                width="fit-content"
              />
            </div>
          ) : null}
          <div style={{ width: "40%" }}>
            <CustomButton
              text={btn2}
              color={
                title == "WARNING" || title == "Confirmation"
                  ? ""
                  : theme.palette.background.default
              }
              submit={handleBtn2}
              fontWeight="600"
              bgcolor={
                title == "WARNING"
                  ? theme.palette.background.default
                  : title == "Confirmation"
                  ? "#30A46C"
                  : "rgba(33, 143, 84, 1)"
              }
              width="100%"
              endIcon={
                (title == "WARNING" || title == "Confirmation") &&
                btn2 &&
                tokens
                  ? tokensCost(tokens)
                  : undefined
              }
            />
          </div>
        </DialogActions>
      ) : null}
    </Dialog>
  );
};
